import TimeframesChart from './TimeframesChart';
import './TimeframesChart.scss';

export default TimeframesChart;